import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const ContactUs = () => {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        fullName: '',
        country: '',
        email: '',
        subject: '',
        message: '',
    });

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({ ...prev, [id]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const { fullName, country, email, subject, message } = formData;

        const whatsappMessage = `${t('contact.whatsappMessage')}\n${t('contact.fullName')}: ${fullName}\n${t('contact.country')}: ${country}\n${t('contact.email')}: ${email}\n${t('contact.subject')}: ${subject}\n${t('contact.message')}: ${message}`;

        const whatsappUrl = `https://wa.me/94779590011?text=${encodeURIComponent(whatsappMessage)}`;

        try {
            const win = window.open(whatsappUrl, '_blank');
            if (!win) {
                alert(`${t('contact.manualMessage')} +94 77 959 0011:\n\n${whatsappMessage}`);
            }
        } catch (error) {
            alert(`${t('contact.errorMessage')} +94 77 959 0011:\n\n${whatsappMessage}`);
        }
    };

    return (
        <div className="py-16 px-4 sm:px-8 lg:px-16 space-y-16 bg-gradient-to-b from-[#FFFFFF] to-[#F8F1E9] min-h-screen">
            {/* Contact Details Section */}
            <div className="max-w-7xl mx-auto">
                <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-center text-[#122C56] mb-12 tracking-tight drop-shadow-md">
                    {t('contact.getInTouch')}
                </h1>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 bg-white p-8 rounded-2xl shadow-2xl transform hover:scale-[1.02] transition-transform duration-300">
                    {[
                        {
                            icon: (
                                <svg className="w-10 h-10 text-[#C58E2F]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                            ),
                            title: t('contact.address'),
                            content: (
                                <>
                                    <p className="text-gray-800 font-medium">Travel with Ashan Sri Lanka</p>
                                    <p className="text-gray-600">293/c/3, Maradana Road Moragalla</p>
                                    <p className="text-gray-600">Beruwala, Sri Lanka</p>
                                </>
                            ),
                        },
                        {
                            icon: (
                                <svg className="w-10 h-10 text-[#C58E2F]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                </svg>
                            ),
                            title: t('contact.mobile'),
                            content: <p className="text-gray-800 font-medium">+94 77 959 0011 - Ashan</p>,
                        },
                        {
                            icon: (
                                <svg className="w-10 h-10 text-[#C58E2F]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                </svg>
                            ),
                            title: t('contact.email'),
                            content: <p className="text-gray-800 font-medium">ashantourssl@gmail.com</p>,
                        },
                        {
                            icon: (
                                <svg className="w-10 h-10 text-[#C58E2F]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                                </svg>
                            ),
                            title: t('contact.website'),
                            content: <p className="text-gray-800 font-medium">www.ashantours.com</p>,
                        },
                    ].map((item, index) => (
                        <div key={index} className="flex items-start space-x-4 p-4 rounded-lg bg-[#F8F1E9] hover:bg-[#E6E0D8] transition-colors duration-200">
                            {item.icon}
                            <div className="space-y-2">
                                <h2 className="text-xl font-semibold text-[#122C56]">{item.title}</h2>
                                {item.content}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Contact Form Section */}
            <div className="max-w-4xl mx-auto">
                <h2 className="text-3xl sm:text-4xl font-bold text-[#122C56] text-center mb-10 drop-shadow-md">
                    {t('contact.sendMessage')}
                </h2>
                <form className="space-y-6 bg-white p-8 rounded-2xl shadow-2xl border-t-4 border-[#C58E2F]" onSubmit={handleSubmit}>
                    {[
                        { id: 'fullName', type: 'text', label: t('contact.fullName'), placeholder: t('contact.fullNamePlaceholder') },
                        { id: 'country', type: 'text', label: t('contact.country'), placeholder: t('contact.countryPlaceholder') },
                        { id: 'email', type: 'email', label: t('contact.email'), placeholder: t('contact.emailPlaceholder') },
                        { id: 'subject', type: 'text', label: t('contact.subject'), placeholder: t('contact.subjectPlaceholder') },
                    ].map((field) => (
                        <div key={field.id} className="flex flex-col space-y-2">
                            <label htmlFor={field.id} className="text-lg font-semibold text-[#122C56]">
                                {field.label}
                            </label>
                            <input
                                id={field.id}
                                type={field.type}
                                className="border border-gray-300 rounded-lg px-4 py-3 text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#C58E2F] transition bg-[#F8F1E9] hover:bg-[#FFFFFF]"
                                value={formData[field.id]}
                                onChange={handleChange}
                                required
                                placeholder={field.placeholder}
                            />
                        </div>
                    ))}
                    <div className="flex flex-col space-y-2">
                        <label htmlFor="message" className="text-lg font-semibold text-[#122C56]">
                            {t('contact.message')}
                        </label>
                        <textarea
                            id="message"
                            rows="6"
                            className="border border-gray-300 rounded-lg px-4 py-3 text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#C58E2F] transition bg-[#F8F1E9] hover:bg-[#FFFFFF]"
                            value={formData.message}
                            onChange={handleChange}
                            required
                            placeholder={t('contact.messagePlaceholder')}
                        ></textarea>
                    </div>
                    <div className="flex justify-end gap-4">
                        <button
                            type="reset"
                            className="px-6 py-3 bg-gray-200 text-[#122C56] font-semibold rounded-lg hover:bg-gray-300 transition duration-200"
                            onClick={() => setFormData({ fullName: '', country: '', email: '', subject: '', message: '' })}
                        >
                            {t('contact.reset')}
                        </button>
                        <button
                            type="submit"
                            className="px-6 py-3 bg-[#C58E2F] text-[#FFFFFF] font-semibold rounded-lg hover:bg-[#A57324] transition duration-200 transform hover:scale-105"
                        >
                            {t('contact.submit')}
                        </button>
                    </div>
                </form>
            </div>

            {/* Location Map Section */}
            <div className="max-w-7xl mx-auto">
                <h2 className="text-4xl sm:text-5xl font-bold text-[#122C56] text-center mb-10 drop-shadow-md">
                    {t('contact.ourLocation')}
                </h2>
                <div className="w-full h-64 sm:h-80 md:h-[32rem] bg-white border-4 border-[#C58E2F] rounded-2xl overflow-hidden shadow-2xl transform hover:scale-[1.01] transition-transform duration-300">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5120.827341632074!2d79.9796875!3d6.456687500000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae22f0145370a5d%3A0x9920872b36440e61!2sTravel%20with%20Ashan%20Beruwala!5e1!3m2!1sen!2slk!4v1759423533121!5m2!1sen!2slk"
                        width="600"
                        height="450"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title={t('contact.mapTitle')}
                        className="w-full h-full"
                    ></iframe>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;